<div class="training-nav-container" [ngClass]="{ collapsed: collapsed }">
  <div class="toggle-nav-button-container">
    <button
      type="button"
      mat-icon-button
      [ngClass]="{ 'collapsed-icon': collapsed }"
      (click)="toggleNav()"
    >
      <mat-icon>keyboard_arrow_left </mat-icon>
    </button>
  </div>
  @if (!collapsed) {
    <button type="button" mat-button class="main-button" (click)="goToHome()">
      <mat-icon>home</mat-icon>Home
    </button>
    <button
      type="button"
      mat-button
      class="main-button"
      (click)="setApp('landing')"
    >
      <span>
        <mat-icon class="app-icon">school </mat-icon>
        @if (currentTab === 'landing' || !currentTab) {
          <span class="indicator"></span>
        }
      </span>

      Training Home
    </button>
  }
  @if (collapsed) {
    <button
      type="button"
      mat-icon-button
      class="main-button"
      (click)="goToHome()"
    >
      <mat-icon>home</mat-icon>
    </button>
    <button
      type="button"
      mat-icon-button
      class="main-button"
      (click)="setApp('landing')"
    >
      <mat-icon class="app-icon">school </mat-icon>
      @if (currentTab === 'landing' || !currentTab) {
        <span class="indicator collapsed"></span>
      }
    </button>
  }

  @for (item of settings; track $index) {
    @if ((mode === 'landing' || mode === 'course') && item.app !== 'landing') {
      @if (!collapsed) {
        @if (
          (item.app !== 'release' && item.app !== 'faq' && showApp(item.app)) ||
          item.app === 'release' ||
          item.app === 'faq'
        ) {
          <button
            type="button"
            mat-button
            class="main-button"
            (click)="setApp(item.app)"
          >
            @if (item.app === 'release') {
              <mat-icon class="app-icon">new_releases </mat-icon>
              @if (currentTab === 'release') {
                <span class="indicator"></span>
              }
            } @else if (item.app === 'faq') {
              <mat-icon class="app-icon">help </mat-icon>
              @if (currentTab === 'faq') {
                <span class="indicator"></span>
              }
            } @else if (item.app === 'ar') {
              <mat-icon class="app-icon">checklist </mat-icon>
              @if (currentTab === 'ar') {
                <span class="indicator"></span>
              }
            } @else {
              <mat-icon
                svgIcon="{{ item.app.toLowerCase() }}_icon"
                class="app-icon"
              />
              @if (currentTab === item.app) {
                <span class="indicator svg-icon-indicator"></span>
              }
            }
            {{ item.title }}
          </button>
        }
      }
      @if (collapsed) {
        @if (
          (item.app !== 'release' && item.app !== 'faq' && showApp(item.app)) ||
          item.app === 'release' ||
          item.app === 'faq'
        ) {
          <button
            type="button"
            mat-icon-button
            class="main-button"
            (click)="setApp(item.app)"
          >
            @if (item.app === 'release') {
              <mat-icon class="app-icon">new_releases </mat-icon>
              @if (currentTab === 'release') {
                <span class="indicator collapsed"></span>
              }
            } @else if (item.app === 'faq') {
              <mat-icon class="app-icon">help </mat-icon>
              @if (currentTab === 'faq') {
                <span class="indicator collapsed"></span>
              }
            } @else if (item.app === 'ar') {
              <mat-icon class="app-icon">checklist </mat-icon>
              @if (currentTab === 'ar') {
                <span class="indicator collapsed"></span>
              }
            } @else {
              <mat-icon svgIcon="{{ item.app }}_icon" class="app-icon" />
              @if (currentTab === item.app) {
                <span class="indicator collapsed svg-icon-indicator"></span>
              }
            }
          </button>
        }
      }
      @if (
        mode === 'course' &&
        item.app === currentTab &&
        item.app !== 'faq' &&
        !collapsed
      ) {
        @if (courses) {
          <div class="courses">
            @for (curr of courses.curriculum; track $index) {
              @if (!curr.right || (curr.right && showCourse(curr.right))) {
                <button
                  type="button"
                  mat-button
                  (click)="setApp(currentTab, curr.videoCode)"
                >
                  <span class="label-container">
                    {{ curr.title }}
                  </span>
                </button>
              }
            }
          </div>
        }
      }
    }
  }
</div>
